import axios from 'axios';
import { strapiApiUrl } from './constants';

/**
 * Shared low-level wrapper for `axios` calls against the Strapi API. Applies
 * `strapiApiUrl` prefix + `withCredentials: true` + a default 30s timeout.
 *
 * Dispatches to the per-verb axios functions (axios.get/post/put/delete) so
 * per-verb mocks in tests keep working.
 */
export const axiosRequest = (method, url, data = undefined, config = {}) => {
  const fullUrl = `${strapiApiUrl}${url}`;
  const baseConfig = {
    withCredentials: true,
    timeout: 30000,
    ...config,
  };
  if (method === 'get' || method === 'delete') {
    return axios[method](fullUrl, baseConfig);
  }
  return axios[method](fullUrl, data, baseConfig);
};
